import { PlatformPersonas } from '../statics/platform/platform-personas.enum';

/**
 * Returns a normalized label string for a given platform persona.
 *
 * Maps persona enums to analytics-friendly groupings:
 * - AGENCY, CLUSTER, DIGITAL, MSSP => "broker"
 * - CUSTOMER => "policyholder"
 * - COWBELL, CARRIER, VENDOR, POOL, RE_INSURER, PREMIUM_PROCESSOR => "cowbell"
 * - Otherwise, returns the string value of the persona in lowercase.
 *
 * @param persona - The persona from PlatformPersonas enum.
 * @returns Analytics label string for the persona.
 */
export function getPersonaLabel(persona: PlatformPersonas): string {
  switch (persona) {
    case PlatformPersonas.AGENCY:
    case PlatformPersonas.CLUSTER:
    case PlatformPersonas.DIGITAL:
    case PlatformPersonas.MSSP:
      return 'broker';

    case PlatformPersonas.CUSTOMER:
      return 'policyholder';

    case PlatformPersonas.COWBELL:
    case PlatformPersonas.CARRIER:
    case PlatformPersonas.VENDOR:
    case PlatformPersonas.POOL:
    case PlatformPersonas.RE_INSURER:
    case PlatformPersonas.PREMIUM_PROCESSOR:
      return 'cowbell';

    default:
      return String(persona).toLowerCase();
  }
}
